<section
  class="block-gallery"
  [class.block-gallery--tiny]="isTinyGallery"
  [class.block-gallery--card]="cardLayout"
>
  <svg
    class="block-gallery__blob block-gallery__blob--glow"
    width="369"
    height="689"
    viewBox="0 0 369 689"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g filter="url(#block-gallery-glow-filter)">
      <circle
        cx="24.3528"
        cy="344.045"
        r="184"
        transform="rotate(75 24.3528 344.045)"
        fill="#29166F"
        fill-opacity="0.4"
      />
    </g>
    <defs>
      <filter
        id="block-gallery-glow-filter"
        x="-319.693"
        y="0"
        width="688.091"
        height="688.091"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="80" result="effect1_foregroundBlur_2352_899" />
      </filter>
    </defs>
  </svg>

  <div class="container">
    <div class="block-gallery__header" *ngIf="showTitles && hasHeaderContent">
      <h2
        *ngIf="title"
        class="block-gallery__title titleTextFont"
        [ngClass]="{ 'cursor-pointer': hasTitleLink() }"
        (click)="goToLink()"
      >{{ title }}</h2>
      <div
        *ngIf="subtitleText"
        class="block-gallery__subtitle fadeIn mb-3 subtitle-block"
        style="font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 16px; line-height: 100%; letter-spacing: 0; text-transform: uppercase; color: #3BB3C3"
      >{{ subtitleText }}</div>
      <div
        class="block-gallery__body"
        *ngIf="bodyHtml"
      >{{ bodyHtml }}</div>
    </div>

    <!-- Skeleton (full) -->
    <div class="block-gallery__stage" *ngIf="loading && !isTinyGallery">
      <div class="block-gallery__photo">
        <div class="skeleton skeleton--image" style="height: 100%"></div>
      </div>
    </div>

    <!-- Skeleton (tiny) -->
    <div class="tiny-gallery" *ngIf="loading && isTinyGallery">
      <div class="tiny-gallery__photos">
        <div class="tiny-gallery__photo" *ngFor="let t of skeletonTiles">
          <div class="skeleton skeleton--image" style="height: 100%"></div>
        </div>
      </div>
    </div>

    <div class="block-gallery__stage" *ngIf="!loading && currentPhoto && !isTinyGallery">
      <svg
        class="block-gallery__blob block-gallery__blob--top"
        width="85"
        height="85"
        viewBox="0 0 85 85"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M69.8091 0.436938C78.4297 -1.95897 86.4111 5.87556 84.1758 14.5391L68.2826 76.1369C66.0472 84.8004 55.2716 87.7953 48.8864 81.5277L3.48777 36.9649C-2.89741 30.6972 -0.103237 19.8678 8.51728 17.4719L69.8091 0.436938Z"
          fill="#29166F"
          fill-opacity="0.4"
        />
      </svg>

      <svg
        class="block-gallery__blob block-gallery__blob--middle"
        width="85"
        height="85"
        viewBox="0 0 85 85"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M69.8091 0.436938C78.4297 -1.95897 86.4111 5.87556 84.1758 14.5391L68.2826 76.1369C66.0472 84.8004 55.2716 87.7953 48.8864 81.5277L3.48777 36.9649C-2.89741 30.6972 -0.103237 19.8678 8.51728 17.4719L69.8091 0.436938Z"
          fill="#29166F"
          fill-opacity="0.4"
        />
      </svg>

      <svg
        class="block-gallery__blob block-gallery__blob--bottom"
        width="85"
        height="85"
        viewBox="0 0 85 85"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M69.8091 0.436938C78.4297 -1.95897 86.4111 5.87556 84.1758 14.5391L68.2826 76.1369C66.0472 84.8004 55.2716 87.7953 48.8864 81.5277L3.48777 36.9649C-2.89741 30.6972 -0.103237 19.8678 8.51728 17.4719L69.8091 0.436938Z"
          fill="#932F29"
          fill-opacity="0.4"
        />
      </svg>

      <div class="block-gallery__frame">
      <div class="block-gallery__photo">
        <picture>
          <img
            [src]="getImage(currentPhoto)"
            [alt]="currentPhoto.title || title"
            onError="this.src='assets/images/placeholder.svg'"
            loading="lazy"
            decoding="async"
          />
        </picture>
      </div>

      <div
        class="block-gallery__caption"
        *ngIf="showCaptions && (currentPhoto.title || currentPhoto.description)"
      >
        <h3 class="block-gallery__caption-title" *ngIf="currentPhoto.title">
          {{ currentPhoto.title }}
        </h3>
        <div
          class="block-gallery__caption-body rich-text"
          *ngIf="currentPhoto.description"
          [innerHTML]="currentPhoto.description | safeHtml"
        ></div>
        <a
          *ngIf="currentPhoto.url"
          class="block-gallery__caption-link"
          [href]="currentPhoto.url"
        >Ver más</a>
      </div>
      </div>

      <div class="block-gallery__controls">
        <button
          type="button"
          class="block-gallery__arrow block-gallery__arrow--prev"
          (click)="prev()"
          aria-label="Anterior"
        >
          <i class="fas fa-chevron-left"></i>
        </button>

        <div class="block-gallery__controls-inner">
          <div class="block-gallery__thumbs">
            <button
              type="button"
              *ngFor="let photo of photos; let i = index"
              class="block-gallery__thumb"
              [class.is-active]="i === currentIndex"
              (click)="selectPhoto(i)"
              [attr.aria-label]="photo.title || 'Foto ' + (i + 1)"
            >
              <img
                [src]="getImage(photo)"
                [alt]="photo.title || ''"
                onError="this.src='assets/images/placeholder.svg'"
                loading="lazy"
                decoding="async"
              />
            </button>
          </div>

          <span class="block-gallery__label" *ngIf="label">{{ label }}</span>
        </div>

        <button
          type="button"
          class="block-gallery__arrow block-gallery__arrow--next"
          (click)="next()"
          aria-label="Siguiente"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="tiny-gallery" *ngIf="!loading && currentPhoto && isTinyGallery">
      <button
        type="button"
        class="tiny-gallery__arrow tiny-gallery__arrow--prev"
        (click)="prev()"
        aria-label="Anterior"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <div class="tiny-gallery__photos">
        <div class="tiny-gallery__photo">
          <picture *ngFor="let photo of tinyPhotos">
            <img
              [src]="getImage(photo)"
              [alt]="photo.title || title"
              onError="this.src='assets/images/placeholder.svg'"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </div>
      </div>

      <button
        type="button"
        class="tiny-gallery__arrow tiny-gallery__arrow--next"
        (click)="next()"
        aria-label="Siguiente"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

  </div>
</section>
